import { A9Service, AbstractDataProviderV2 } from 'components/system';

@A9Service('customerExpenditureYearStatisticsDataProvider')
export class CustomerExpenditureMonthStatisticsDataProvider extends AbstractDataProviderV2 {
    constructor() {
        super();
        this.setApiUrl('middle://customers/statistics/expenditure-year/{customerId}/{year}');
    }
}
